import { announceConstants } from '../_constants';

export function announce(state = {}, action) {
    
    switch (action.type) {
        case announceConstants.CREATE_REQUEST:
            return {
                announce: action.announce
            };
        case announceConstants.CREATE_SUCCESS:
            return {
                announce: action.announce
            };
        case announceConstants.CREATE_FAILURE:
            return {};
        case announceConstants.UPDATE_REQUEST:
            return {
                announce: action.announce
            };
        case announceConstants.UPDATE_SUCCESS:
            return {
                announce: action.announce
            };
        case announceConstants.UPDATE_FAILURE:
            return {};
        case announceConstants.GETALL_REQUEST:
            return {
                loading: true
            };
        case announceConstants.GETALL_SUCCESS:
            return {
                announce: action.announce,
            };
        case announceConstants.GETALL_FAILURE:
            return {
                error: action.error
            };
        case announceConstants.DELETE_REQUEST:
            // add 'deleting:true' property to user being deleted
            return {
                ...state,
                items: state.items.map(order =>
                    order.id === action.id
                        ? { ...order, deleting: true }
                        : order
                )
            };
        case announceConstants.DELETE_SUCCESS:
            // remove deleted user from state
            return {
                items: state.items.filter(user => user.id !== action.id)
            };
        case announceConstants.DELETE_FAILURE:
            // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
            return {
                ...state,
                items: state.items.map(order => {
                    if (order.id === action.id) {
                        // make copy of user without 'deleting:true' property
                        const { deleting, ...orderCopy } = order;
                        // return copy of user with 'deleteError:[error]' property
                        return { ...orderCopy, deleteError: action.error };
                    }

                    return order;
                })
            };
        default:
            return state
    }
}